/**
 * Slide-show template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

require('./lib/GSAP');

import el from './lib/elements';
import evt from './lib/events';
import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Slide-show';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

// Bootstrap global functionality
Global();

const slide_show_slides   = document.querySelectorAll(".slide-show__slide");
const prev_btn            = el.id('prev_btn');
const next_btn            = el.id('next_btn');
const slide_pos           = el.id('slide_pos');
const slide_show_controls = el.id('slide-show_controls');
const slide_show          = new Map([
	['hash', null],
	['hash_last', null],
	['max-slides', Number(window.single_vars.max_slides) || 6],
	['determineHashAndSetHistory', () => {
		if (window.location.hash && window.location.href.indexOf("#") !== -1) {
			// Hash found with a value, check if it’s a valid value (and correct if necessary) before storing, then,
			// set hash (this is fallback for correction of bogus values)
			slide_show.set('hash', window.location.hash = Number(slide_show.get('checkRange')(window.location.hash.substring(1))));
			// console.warn(`found existing ${slide_show.get('hash')}` );
		} else {
			// Set has hash
			slide_show.set('hash', Number(window.location.hash = '1'));
		}
		return slide_show.get('hash');
	}],
	['checkRange', (nbr) => {
		return nbr > 0 && nbr <= slide_show.get('max-slides') ? nbr : 1
	}],
	['direction', null]
]);


function init() {
	// Logger.log(`${NAME} > init`);

	for (let i = slide_show.get('max-slides'); i--;) gsap.set(slide_show_slides[i], {xPercent: 123, visibility: 'visible', scale: .8});

	onHash(null);

	setTimeout(() => {
		slide_show_controls.classList.add('slide-show-controls--vis');
		addHandlers();
	}, 900);
}

/**
 * addHandlers --- Add event handlers for view
 */
function addHandlers() {
	// Logger.log(`${NAME} > addHandlers`);
	evt.add(window, 'hashchange', onHash);
	evt.add(slide_show_controls, 'click', onSlide);
}

function onSlide(evt) {
	const target = evt.target;
	const hash   = slide_show.get('hash');
	switch (target.id) {
		case 'prev_btn':
			slide_show.set('direction', 'left');
			slide_show.set('hash_last', hash);
			slide_show.set('hash', Number(window.location.hash = hash - 1));
			break;
		case 'next_btn':
			slide_show.set('direction', 'right');
			slide_show.set('hash_last', hash);
			slide_show.set('hash', Number(window.location.hash = hash + 1));
			break;
	}
}

/**
 * onHash --- Listen for hash update
 * @param evt
 */
function onHash(evt) {
	const dir           = slide_show.get('direction');
	const slide_last    = el.id(`slide-show_${slide_show.get('hash_last')}_slide`);
	const hash          = slide_show.get('determineHashAndSetHistory')();
	const slide_current = el.id(`slide-show_${hash}_slide`);
	const max           = slide_show.get('max-slides');
	slide_pos.innerHTML = `${hash} of ${max}`;
	Logger.log(`${NAME} > onHash ${location.href}`);

	// Takes care of controls on bottom
	if (hash === 1) {
		prev_btn.setAttribute('disabled', '');
		next_btn.removeAttribute('disabled');
	} else if (hash === max) {
		prev_btn.removeAttribute('disabled');
		next_btn.setAttribute('disabled', '');
	} else {
		prev_btn.removeAttribute('disabled');
		next_btn.removeAttribute('disabled');
	}

	// Move all other slides (only if a direction has been set)
	dir && slide_show_slides.forEach((el) => {
		if (el.id !== `slide-show_${hash}_slide` && el.id !== slide_last.id) {
			if (dir === 'right') {
				gsap.set(el, {xPercent: 123});
			} else {
				gsap.set(el, {xPercent: -123});
			}
			el.classList.add('slide-show__slide--dormant');
		} else if (el.id !== slide_last.id) {
			slide_last.classList.add('slide-show__slide--dormant');
		}
	});

	slide_current.classList.remove('slide-show__slide--dormant');

	if (dir === 'right') {
		if (slide_last && slide_show.get('hash_last') !== hash) {
			// console.log('last slide found, move left and scale');
			gsap.to(slide_last, {
				scale: .8,
				duration: .3,
				onComplete: () => gsap.to(slide_last, {xPercent: -123})
			});
		}

		gsap.fromTo(slide_current, {xPercent: 120}, {
			xPercent: 0,
			duration: .4,
			delay: slide_last ? .34 : 0,
			ease: "timingFuncEaseOutBack2",
			onStart: () => gsap.to(slide_current, {
				scale: 1,
				duration: .13,
				delay: slide_last ? .3 : .11,
				ease: "none"
			})
		});
	} else {
		if (slide_last && slide_show.get('hash_last') !== hash) {
			// console.log('last slide found, move right and scale');
			gsap.to(slide_last, {
				scale: .8,
				duration: .3,
				onComplete: () => gsap.to(slide_last, {xPercent: 123})
			});
		}
		gsap.fromTo(slide_current, {xPercent: -120}, {
			xPercent: 0,
			duration: .4,
			delay: slide_last ? .34 : 0,
			ease: "timingFuncEaseOutBack2",
			onStart: () => gsap.to(slide_current, {
				scale: 1,
				duration: .13,
				delay: slide_last ? .3 : .11,
				ease: "none"
			})
		});
	}
}

init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
